import { debouncedRebuildReactTooltip } from '../../debouncedRebuildReactTooltip';

const isEllipsis = domElement => {
  if (!domElement) {
    return false;
  }
  return domElement.offsetWidth < domElement.scrollWidth;
};

// JS cell renderer to improve performance
export class JSDiagnosticsReportCellRenderer {
  init(params) {
    this.eGui = document.createElement('div');
    this.eGui.classList.add('diagnostics-report-cell');

    this.cellValue = this.getValueToDisplay(params);
    this.eGui.innerHTML = this.cellValue;

    this.intervalId = setInterval(() => {
      if (isEllipsis(this.eGui) && params.tooltipContentField) {
        this.eGui.setAttribute('data-tip', params.data[params.tooltipContentField]);
        debouncedRebuildReactTooltip();
      } else {
        this.eGui.removeAttribute('data-tip');
        debouncedRebuildReactTooltip();
      }
    }, 500);
  }

  getGui() {
    return this.eGui;
  }

  refresh(params) {
    this.cellValue = this.getValueToDisplay(params);
    this.eGui.innerHTML = this.cellValue;

    return true;
  }

  destroy() {
    clearInterval(this.intervalId);
  }

  // eslint-disable-next-line class-methods-use-this
  getValueToDisplay(params) {
    return `${(params.valueFormatted ? params.valueFormatted : params.value) || ''}`;
  }
}
